<div class="bg-overlady" *ngIf="showLoader">
  <div class="loader-position">
    <div class="loader"></div>
    <h2>Loading....</h2>
  </div>
</div>
<div class="hold-transition login-page form-group" style="margin-bottom: 0;">
<div class="col-md-6">
  <img src="../../assets/img/Logo/clipart.png" class="login-clip">
</div>

<div class="col-md-6">
  <div class="login-box">
    <!-- <div class="login-logo text-center col-md-6">
      <h3>
        Corporate<br />
        Renaissance Group
      </h3>
      <img src="../../assets/img/Logo/CRGLogo1.png" width="100px" />
    </div> -->
    <div class="login-box-body col-md-12">

      <img src="../../assets/img/Logo/CRGLogo.png" class="loginglogo" style="width: 250px; margin: 20px 0 50px;"/>
        <p class="login-box-msg signIn">Login to your account</p>
     

      <form name="form">
        <span class="error">{{ UserError }}</span>
        
        <div class="form-group has-feedback" *ngIf="showEmail">
        <div class="form-group has-feedback" >
          <input
            type="text"
            class="form-control txtclass"
            (keydown.enter)="SignIn()"
            req="1"
            Email="1"
            name="emailid"
            placeholder="Email"
            [(ngModel)]="EmailId"
            (change) = "ResetAttempts()"
            (click) = "OnPasswordLogin()"
         
       
          />
          <span
            class="glyphicon glyphicon-envelope form-control-feedback"
            style="top: 3px"
          ></span>
        </div>

        
 
        </div>
        <div *ngIf="OrOption" style="text-align: center; margin-bottom: 10px;">
          <hr style="margin: 0;
          position: relative;
          top: 9px;
          z-index: 9;">
        <span style="background: #fff;
        position: relative;
        z-index: 99;
        padding: 0 7px;
        top: -1px;">OR</span>



        
        </div>
        <div class="row">
          
          <div class="col-md-12 no-padding form-group" *ngIf="showPhone">
          <div style="display: inline-flex;
          width: 100%; border: 2px solid #dfe0e0 !important; border-radius: 5px;">
            <div *ngIf="showisdCode" class="numcode" style="border-right: 2px solid #dfe0e0; display: flex; align-items: center;">
              <span style="padding-left: 5px; padding-top: 3px;"><img height="14px" width="20px" src="{{Countryflag}}"></span>
              <ejs-dropdownlist  [(ngModel)]="countryCode" [(value)] = "countryCode" [dataSource]='ISDCode' [fields]='fields' [placeholder]="text" #ISD (change)= "setCountryCode(ISD)"  [itemTemplate]='itemTemplate'>
                <ng-template #itemTemplate="" let-data>
                 <span class='name'> <span><img height="14px" width="20px" src="{{data.flag}}"></span> {{ data.code }}  </span> 
              </ng-template>
              </ejs-dropdownlist>
            </div>

            <div class="has-feedback" *ngIf="showPhone" style="width: 100%;">
              <input #lykan
                type="number"
                class="form-control txtclass"
                req="1"
                name="Phone"
                placeholder="Phone"
                (click) = "OnPhoneLogin()"
                [(ngModel)]="Phone"
                [disabled] = "disableMobile" style="border: none !important;padding-top: 20px; padding-bottom: 16px;"
              />
              <span
                class="glyphicon glyphicon-phone form-control-feedback"
                style="top: 3px"
              ></span>
            </div>
          </div>
          </div>
        </div>
        <div *ngIf="showOtp">
          <div class="form-group has-feedback" style="margin-bottom: 0;">
            <input
              type="number"
              class="form-control txtclass"
              req="1"
              (keydown.enter)="LoginByOTP()"
              name="OTP"
              placeholder="Enter OTP"
              [(ngModel)]="OTPget"
            />
            <span
              class="glyphicon glyphicon-lock form-control-feedback"
              style="top: 3px"
            ></span>
          </div> 
        </div>
        <div *ngIf="showPassword">
          <div class="form-group has-feedback" style="margin-bottom: 0;">
            <input
              type="password"
              class="form-control txtclass"
              req="1"
              (keydown.enter)="SignIn()"
              name="Password"
              placeholder="Password"
              #passwordInput
              (input)= "onPasswordEnter(passwordInput.value)"
             
    
            />
            <span
              class="glyphicon glyphicon-lock form-control-feedback"
              style="top: 3px"
            ></span>
          </div> 
        </div>
       
        <div class="text-success"   
        style="white-space: pre; margin-bottom: 5px;display: inline-flex;align-items: center;width: 100%;justify-content: space-between;" >
        <span class="error" style="white-space: pre; margin-top: 8px;" *ngIf="errormsg">{{
          errorMessage
        }}</span>
        
          <span *ngIf="display != 'Get OTP again in 00:00' && errormsg && showOtp " class="text-success" >
              <span id="timer">{{display}}</span></span>
           
        </div>
      
        <div class="text-success"   
        style="white-space: pre; margin-bottom: 0px;display: inline-flex;align-items: center;width: 100%;justify-content: space-between;" >
          <span *ngIf="successmsg" >{{errorMessage}}</span>
        
            <button *ngIf="display == 'Get OTP again in 00:00' && showOtp  "
              type="submit"
              class="btn btn-primary"
              (click)="RegetOTP()"
              style="font-size: 11px;"
            >
            Resend OTP
            </button>

            <span *ngIf="display != 'Get OTP again in 00:00' && successmsg && display  " class="text-success" >
               <span id="timer">{{display}}</span></span>
           
        </div>
      
      
        
        <!-- <span class="text-success" style="white-space: pre; margin-bottom: 5px;" *ngIf="checkInterval">{{
          <button (click)="getOTP()">Resend</button>
        }}</span> -->
            <div class="col-md-12 no-padding" *ngIf="remmbermeTab">
              <div class="col-md-6 no-padding" style="    position: relative;
              top: -2px;">
                <input type="checkbox"> Remember Me
              </div>            
              <div class="form-group has-feedback pull-right forgot col-md-6 no-padding" style="margin-bottom: 0;">
                <a href="javascript:void(0)" (click)="showForgotPasswordModal()"
                  >Forgot Password?</a
                >
              </div>
            </div>
        
      </form>
      <div class="text-center" *ngIf="showPassword">
        <button
          type="submit"
          class="btn btn-primary btn-block btn-flat loginbtb"
          (click)="SignIn()"
        >
          Login
        </button>
      </div>
   
      <div class="text-center" *ngIf="showGetOtp">
        <button
          type="submit"
          class="btn btn-primary btn-block btn-flat loginbtb"
          (click)="getOTP()"
        >
        Generate OTP
        </button>
      </div>
      <div class="text-center" *ngIf="showOtp">
        <button
          type="submit"
          class="btn btn-primary btn-block btn-flat loginbtb"
          (click)="LoginByOTP()"
        >
        Authenticate
        </button>
      </div>
      <!-- <br />
      <div class="text-center" style="margin-bottom: 10px !important;">Or</div>
      <div style="margin-bottom: 15px !important;">
        <span
          style="white-space: pre; color: #f0483e;">{{gAuthErrorMessage}}</span>
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-social" style="background-color: #f0483e; color: white;"
          (click)="socialSignIn(false)">
          <span class="fa fa-google"></span>
          Sign in with Google</button>
      </div> -->
<div class="form-group" style="display: flex;" >
  <img src="../../assets/img/Logo/social-lgin.jpg" style="width: 260px;
  margin-top: 15px;" class="sign-in-using">
  <img src="/assets/img/Logo/Coming-Soon.gif" style="margin-top: 60px;height: 12px;" class="purs">
</div>
 <!-- <h6>Sign In Using</h6>
<div class="form-group" style="display: flex;" >

  <a class="oauth-container btn darken-4 primary black-text" >
    <i class="fa fa-apple  white-text mr-md-3 mr-2 fa-2x"> </i>
  </a>
<a class="oauth-container btn darken-4 primary black-text" (click)="onGoogleSignIn()" >
  <i class="fa fa-google white-text mr-md-3 mr-2 fa-2x"> </i>
</a>
<a class="oauth-container btn darken-4 primary black-text" >
  <i class="fa fa-windows  white-text mr-md-3 mr-2 fa-2x"> </i>
</a>
<a class="oauth-container btn darken-4 primary black-text" >
  <i class="fa fa-linkedin  white-text mr-md-3 mr-2 fa-2x"> </i>
</a>
<a class="oauth-container btn darken-4 primary black-text" >
  <i class="fa fa-facebook  white-text mr-md-3 mr-2 fa-2x"> </i>
</a>
<a class="oauth-container btn darken-4 primary black-text" >
  <i class="fa fa-twitter  white-text mr-md-3 mr-2 fa-2x"> </i>
</a>
</div> -->
<div class="form-group">
  <div class="col-md-12 no-padding form-group has-feedback" *ngIf="LoginWithEmail">
    <a href="javascript:void(0)" (click)="OnLoginWithEmail()" style="cursor: pointer; color: #005880; font-weight: 500; border-top: 1px solid #ccc;
    padding: 10px 0;position: relative; display: inline-block; width:100%;top: 20px;">Login With Email</a>
  </div>
  <div class="col-md-12 no-padding form-group has-feedback" *ngIf="LoginWithNumber">
    <a href="javascript:void(0)" (click)="OnLoginWithNumber()" style="cursor: pointer;color: #005880; font-weight: 500;
    border-top: 1px solid #ccc; padding: 10px 0;position: relative;display: inline-block; width:100%; top: 20px;">Login With Mobile Number</a> 
  </div>

</div>
     
    </div>
  </div>
</div>
</div>
<div id="ForgotPasswordModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-md" style="width: 400px;">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">Forgot Password</h4>
      </div>
      <div class="modal-body row lessrow" style="padding:0;">
        <div class="col-sm-12 model-body" style="padding: 0 0 20px;">
          <form name="form">
            <div class="m-portlet__body">
              <div class="form-group master-form-group row">
                <div class="col-lg-12">
                  <label>Email <span class="red">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Email Address"
                    name="email"
                    [(ngModel)]="forgotPassword.email" style="padding-left: 10px;"
                  />
                  <span
                    class="error"
                    *ngIf="
                      resetPasswordSubmitted && !forgotPassword.email.length
                    "
                    >Email required</span
                  >
                  <span class="error" *ngIf="forgotPassword.message.length">{{
                    forgotPassword.message
                  }}</span>
                </div>
              </div>
              <div class="form-group master-form-group row">
                <div class="col-lg-12 text-center">
                  <button
                    type="button"
                    class="btn btn-brand"
                    (click)="getForgotPasswordToken()" style="margin-top: 10px;"
                  >
                    Reset Password
                  </button>
                  <!-- <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    Close
                  </button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="MessageModal" class="modal  fade" role="dialog">
  <div class="modal-dialog modal-confirm modal-md" style="width: 300px;">
    <div class="modal-content" style="border-radius:10px">
      <div class="modal-header success-header">
        <div class="icon-box">
          <i class="fa fa-check"></i>
        </div>
      </div>
      <div class="modal-body">
        <p class="text-center">{{ modalMessage }}</p>
      </div>
      <div class="modal-footer errorbutton">
        <button class="btn btn-success messagebutton" data-dismiss="modal">
          OK
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade right bg-white" id="MultiUser" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="false">
  <div class="modal-dialog modal-side modal-bottom-right modal-notify modal-info" role="document" style="width: 450px;">
    <!--Content-->
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header" style=" border-bottom: 1px solid #ddd; background-color: #ffffff !important; ">
        <p class="heading"  style="font-size: 22px;color: #222; margin-bottom: 0;"><b>Action Required</b>
        </p>
        <button  class="close" data-dismiss="modal" (click)="userback()" type="button"> × </button>
      </div>

      <!--Body-->
      <div class="modal-body" style="background-color: transparent !important;">
        <div class="row">
          <div class="col-2">
            <p class="text-center" style="margin-bottom: 0;"><i class="fa fa-user fa-4x" style="color: #005880 !important; background: #eee; width: 80px; height: 80px;
              display: inline-block; border-radius: 50%; padding-top: 11px;"></i></p>
          </div>

          <div class="col-9 multiComp" style="padding: 5%;">
              <button style="
              width: 100%;
              background-color: #005880;
               border-color:#005880;
              margin-bottom: 5%;
              padding: 3%;
          "  *ngFor="let item of multiUserInfo" data-dismiss="modal" type="button" (click)="UsuerChoosedCompony(item.companyId)" class="btn btn-info">{{item.companyName}}</button>
          
          </div>
        </div>
      </div>
      <!-- #005880 -->
      <!--Footer-->
      <!-- <div class="modal-footer justify-content-center" style="border-width: 5px; background-color: #ffffff !important; border-color:#005880 !important">   
         <button type="button" class="close"  data-dismiss="modal" (click)="userback()">
          <a style="background-color: #033c57 !important; border-color:#033c57 !important" type="button" class="btn btn-info" >Close</a>
        </button>
      </div> -->
    </div>
    <!--/.Content-->
  </div>
</div>